import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

const VUES_COCKPIT_SYNCUP = [
  {
    cle: 'diagnostics',
    chemin: '/cockpit/syncup',
    titre: 'Diagnostics',
    question: 'Pourquoi cette experience SyncUp ne fonctionne-t-elle pas ?',
    intention: 'Recherche, flux, preuves et projection visible.',
    Icone: SearchIcon,
  },
  {
    cle: 'catalogue',
    chemin: '/cockpit/syncup/catalogue',
    titre: 'Catalogue des flux',
    question: 'Quels flux sont connus et lesquels restent a interpreter ?',
    intention: 'Structure progressive pour les prochains diagnostics.',
    Icone: AccountTreeIcon,
  },
];

const useStyles = makeStyles((theme) => ({
  enveloppe: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    border: '1px solid #e5e7eb',
    boxShadow: 'none',
  },
  entete: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1),
  },
  question: {
    color: '#374151',
    fontWeight: 600,
  },
  intention: {
    color: '#6b7280',
    fontSize: 12,
  },
  nav: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
    gap: theme.spacing(1),
  },
  bouton: {
    justifyContent: 'flex-start',
    textAlign: 'left',
    minHeight: 46,
    textTransform: 'none',
  },
  boutonActif: {
    justifyContent: 'flex-start',
    textAlign: 'left',
    minHeight: 46,
    textTransform: 'none',
    borderColor: '#111827',
    backgroundColor: '#f9fafb',
  },
}));

const CockpitSyncUpNavigation = ({ vueActive }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const vue = VUES_COCKPIT_SYNCUP.find((item) => item.cle === vueActive)
    || VUES_COCKPIT_SYNCUP.find((item) => item.chemin === location.pathname)
    || VUES_COCKPIT_SYNCUP[0];

  return (
    <Paper className={classes.enveloppe}>
      <div className={classes.entete}>
        <div>
          <Typography variant="overline">Cockpit SyncUp</Typography>
          <Typography variant="body1" className={classes.question}>{vue.question}</Typography>
          <Typography variant="body2" className={classes.intention}>{vue.intention}</Typography>
        </div>
      </div>
      <div className={classes.nav}>
        {VUES_COCKPIT_SYNCUP.map((item) => {
          const Icone = item.Icone;
          const actif = item.cle === vue.cle;
          return (
            <Button
              key={item.cle}
              variant="outlined"
              size="small"
              startIcon={<Icone />}
              className={actif ? classes.boutonActif : classes.bouton}
              onClick={() => history.push(item.chemin)}
            >
              {item.titre}
            </Button>
          );
        })}
      </div>
    </Paper>
  );
};

export default CockpitSyncUpNavigation;



// WEBPACK FOOTER //
// src/components/cockpitSyncUp/CockpitSyncUpNavigation.js